import React from 'react';
import classNames from 'classnames';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info';
  solid?: boolean;
  dot?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const Badge: React.FC<BadgeProps> = ({
  children,
  className,
  variant = 'default',
  solid = false,
  dot = false,
  size = 'md',
  ...rest
}) => {
  const variantClasses = solid
    ? {
        default: 'bg-gray-600 text-white',
        primary: 'ecme-badge-solid-primary',
        success: 'ecme-badge-solid-success',
        warning: 'bg-warning text-white',
        error: 'ecme-badge-solid-danger',
        info: 'bg-info text-white',
      }
    : {
        default: 'ecme-badge-default',
        primary: 'ecme-badge-primary',
        success: 'ecme-badge-success',
        warning: 'ecme-badge-warning',
        error: 'ecme-badge-error',
        info: 'ecme-badge-info',
      };

  const sizeClasses = {
    sm: 'text-[10px] px-2 py-0.5',
    md: '',
    lg: 'text-sm px-3 py-1.5',
  };

  const classes = classNames(
    'ecme-badge',
    variantClasses[variant],
    sizeClasses[size],
    className
  );

  if (dot) {
    return (
      <span className={classes} {...rest}>
        <span
          className={classNames('ecme-badge-dot', {
            'bg-gray-500': variant === 'default',
            'bg-primary': variant === 'primary',
            'bg-success': variant === 'success',
            'bg-warning': variant === 'warning',
            'bg-error': variant === 'error',
            'bg-info': variant === 'info',
          })}
        />
        {children}
      </span>
    );
  }

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
};

export default Badge;
